"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

var Input = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, (0, _utils.sanitizeInputProps)(props), {
    ref: ref
  }));
});
Input.propTypes = {
  id: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  type: _propTypes.default.string,
  name: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onChange: _propTypes.default.func
};
Input.defaultProps = {
  type: 'text',
  onChange: _utils.noop
};
Input.displayName = 'Input';
var _default = Input;
exports.default = _default;